/**
 * ab实验逻辑封装
 */
import { Vue, Component } from 'vue-property-decorator';
import { getAbTestUser } from '@/api/user';
import { AbTestEnum, DivideEnum } from '@/api/user/types';

@Component
export default class AbTest extends Vue {
  /** 记录当前Ab结果，后续可在其他页面直接用 */
  protected abRes = false;

  /** 不传platform类型默认全平台支持 */
  protected async getAbTest(divideType: DivideEnum, productIdList?: string[]): Promise<boolean> {
    let isAbTest = false;
    try {
      isAbTest = (
        await getAbTestUser({ divideType, productIdList })
      ).divideRes === AbTestEnum.waitHint;
    } catch {
      isAbTest = false;
    }
    this.abRes = isAbTest;
    return isAbTest;
  }
}
